<template>
  <div>
    <nav class="navbar navbar-light bg-white">
      <a class="navbar-brand" href="#">
        <img src="@/assets/logo.png" class="d-inline-block align-top" width="250">
      </a>
    </nav>
    <div class="row">
      <div class="col-md-4 mt-3 text-left">
        <strong>Olá</strong>, <i>{{user.name}}</i>!
      </div>
      <div class="col-md-6 mt-3">
        <div class="row" v-if="showCombo">
          <div class="col text-right mt-2">
            Selecione sua assinatura:
          </div>
          <div class="col ml-n3">
            <select title="Selecione a assinatura" @change="selecionarSubscription" class="form-control"
              v-model="selecionadaSubscription" style="width: 300px;">
              <option v-for="subs in listaAssinaturas" :key="subs.id" :value="subs">
                <span>
                  {{ subs.id }} - {{ subs.descricao }}
                  <span v-if="subs.status === 'CANCELED'">(Cancelada)</span>
                </span>
              </option>
            </select>
          </div>
        </div>
  
      </div>
      <div class="col-md-2 mt-3 text-right">
        <a href="#" @click="exitSystem" class="link-padrao"><i class="fas fa-door-open mr-1"></i> Sair</a>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus';

export default {
  mounted() {
    this.topRules()
    this.loadCombo()
  },
  data() {
    return {
      user: {
        profile: null,
        name: null
      },
      selecionadaSubscription: {},
      listaAssinaturas: [],
      showCombo: false
    }
  },
  emits: ['selecionar-assinatura', 'assinatura'],
  methods: {
    topRules() {
      this.user.profile = localStorage.getItem("profile")
      this.user.name = localStorage.getItem("name")
    },
    exitSystem() {
      localStorage.removeItem("profile")
      localStorage.removeItem("token")
      localStorage.removeItem("name")
      localStorage.removeItem("cpf")
      sessionStorage.removeItem("selectedSubscription")
      sessionStorage.removeItem("subscriptionData")
      location.href = '/'
    },
    selecionarSubscription() {
      this.$emit('selecionar-assinatura', this.selecionadaSubscription.id);
      this.$emit('assinatura', this.selecionadaSubscription);
      EventBus.$emit('assinatura-selecionada', this.selecionadaSubscription.id);
      sessionStorage.setItem('selectedSubscription', JSON.stringify(this.selecionadaSubscription));

    },
    loadCombo() {
      const selectedSubscription = sessionStorage.getItem('selectedSubscription');
      const subscriptionData = sessionStorage.getItem('subscriptionData');

      if (selectedSubscription && subscriptionData) {
        this.selecionadaSubscription = JSON.parse(selectedSubscription);
        this.listaAssinaturas = JSON.parse(subscriptionData);
        this.showCombo = this.listaAssinaturas.length > 1;
        this.selecionarSubscription();
      } else {
        this.$clubApi.get('/subscription/load').then((response) => {
          this.listaAssinaturas = response.data.object;
          if (this.listaAssinaturas.length > 0) {
            this.selecionadaSubscription = this.listaAssinaturas[0];
            this.showCombo = this.listaAssinaturas.length > 1;

            // Armazenar dados no sessionStorage
            sessionStorage.setItem('selectedSubscription', JSON.stringify(this.selecionadaSubscription));
            sessionStorage.setItem('subscriptionData', JSON.stringify(this.listaAssinaturas));
            this.selecionarSubscription();
          }
        }).catch((error) => {
          this.$notify({ type: 'warning', message: error.response.data.msg })
        });
      }
    },


  }
}   
</script>